import { flowSteps } from '@/mocks/homeContent';

export default function FlowSection() {
  return (
    <section id="flow" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            SERVICE FLOW
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            ご依頼から作業完了までの<span className="text-primary-500">流れ</span>
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            はじめてのお客様でも安心。京都 不用品回収・京都 遺品整理・京都 ゴミ屋敷清掃、いずれの依頼も同じ流れです。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {flowSteps.map((s, idx) => (
            <div
              key={s.step}
              className="relative p-7 rounded-lg bg-background-50 border border-background-200"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="w-14 h-14 flex items-center justify-center rounded-md bg-accent-700 text-background-50">
                  <span className="w-7 h-7 flex items-center justify-center text-2xl">
                    <i className={s.icon} />
                  </span>
                </div>
                <div>
                  <p className="font-mincho text-primary-600 tracking-widest text-xs">
                    STEP {s.step}
                  </p>
                  <h3 className="text-lg md:text-xl font-bold text-foreground-950">
                    {s.title}
                  </h3>
                </div>
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed">{s.desc}</p>

              {/* Arrow between cards on large screens */}
              {idx < flowSteps.length - 1 && (
                <div className="hidden lg:flex absolute -right-3 top-1/2 -translate-y-1/2 w-6 h-6 items-center justify-center text-primary-400">
                  <span className="w-6 h-6 flex items-center justify-center text-3xl">
                    <i className="ri-arrow-right-s-line" />
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}